import { PayloadAction } from "@reduxjs/toolkit";
import { all, call, put, select, takeLatest } from "redux-saga/effects";
import {onLanguageDetailsSuccess, setTokenDetails, onCountryUserListSuccess} from "../slice/loginSlice";
import JWTInterceptor from "../../api/JWT/JWTInterceptor";
import { setLoader } from "../slice/generalSlice";
import axios from "axios";

function* getUserAccessMenuDetails(): Generator<any, void, any> {
  yield put(setLoader(true));
  try {
    const response = yield JWTInterceptor.get(`${process.env.REACT_APP_Admin_APP_BASE_URL}UserAccess/getModuleAccessnavigation`);
    if (response.status === 200) {
      const moduleNav = response.data;
      console.log("moduleNav", moduleNav);
      yield put(
        {
          type: "updateLoginDetails",
          payload: {
            name: "sideMenuData",
            value: moduleNav.serviceResponse.mainModuleResponseDto || [],
          },
        }
      );
    } else {
    //   const errorData: Error = {
    //     status: response.status,
    //     message: response.data,
    //   };
    //   yield put(setError({ error: errorData }));
    }
  } catch (error) {
    // const errorData: Error = {
    //   status: RESPONSE_STATUS.EXCEPTION,
    //   message: "Something Went Wrong",
    // };
    // yield put(setError({ error: errorData }));
  } finally {
   yield put(setLoader(false));
  }
}

function* getUserCountryDetails(): Generator<any, void, any> {
  yield put(setLoader(true));
  try {
    const response = yield JWTInterceptor.get(`${process.env.REACT_APP_Admin_APP_BASE_URL}UserAccess/getuserCountryList`);
    console.log(response);
    if (response.status === 200) {
      const countryDetails = response.data;
      console.log("countryDetails", countryDetails);

      yield put(
        onCountryUserListSuccess(countryDetails.serviceResponse)
      );

      // yield put(
      //   onCountryUserListSuccess({
      //     name: null,
      //     value: countryDetails.serviceResponse,
      //   })
      // );
    } else {
    //   const errorData: Error = {
    //     status: response.status,
    //     message: response.data,
    //   };
    //   yield put(setError({ error: errorData }));
    }
  } catch (error) {
    // const errorData: Error = {
    //   status: RESPONSE_STATUS.EXCEPTION,
    //   message: "Something Went Wrong",
    // };
    // yield put(setError({ error: errorData }));
  } finally {
   yield put(setLoader(false));
  }
}

function* getLanguageDetails(): Generator<any, void, any> {
  console.log("getLanguageDetails called");
  yield put(setLoader(true));
  try {
    const response = yield JWTInterceptor.get(`${process.env.REACT_APP_MASTERS_API_BASE_URL}Master/getlanguages`);
    console.log(response);
    if (response.status === 200) {
      const countryDetails = response.data;
      console.log("countryDetails", countryDetails);

      // yield put(
      //   {
      //     type: "updateCountryDetails",
      //     payload: {
      //       name: "sideMenuData",
      //       value: countryDetails.serviceResponse,
      //     },
      //   }
      // );

      yield put(onLanguageDetailsSuccess(countryDetails));

      // yield put(
      //   onCountryUserListSuccess({
      //     name: null,
      //     value: countryDetails.serviceResponse,
      //   })
      // );
    } else {
    //   const errorData: Error = {
    //     status: response.status,
    //     message: response.data,
    //   };
    //   yield put(setError({ error: errorData }));
    }
  } catch (error) {
    // const errorData: Error = {
    //   status: RESPONSE_STATUS.EXCEPTION,
    //   message: "Something Went Wrong",
    // };
    // yield put(setError({ error: errorData }));
  } finally {
   yield put(setLoader(false));
  }
}

function* getTokenDetails(action: PayloadAction<any>): Generator<any, void, any> {
  console.log("gettoken details called");
  //yield put(setLoader(true));
  try {
    // const response = yield axios.get(`${process.env.REACT_APP_OKTA_API_BASE_URL}getoktaaccesstoken?authorizationCode=${authcode}&codeVerifier=${code}`)
    // console.log(response);
    yield put(setLoader(true));
    const apiUrl = `${process.env.REACT_APP_OKTA_API_BASE_URL}getoktaaccesstoken?authorizationCode=${action.payload.code}&codeVerifier=${action.payload.codeVerifier}`;
    const response: any = yield call(axios.get, apiUrl);
    if (response.status === 200) {
      const countryDetails = response.data;
      console.log("countryDetails", countryDetails);

      // yield put(
      //   {
      //     type: "updateCountryDetails",
      //     payload: {
      //       name: "sideMenuData",
      //       value: countryDetails.serviceResponse,
      //     },
      //   }
      // );

      yield put(setTokenDetails(countryDetails));

      // yield put(
      //   onCountryUserListSuccess({
      //     name: null,
      //     value: countryDetails.serviceResponse,
      //   })
      // );
    } else {
    //   const errorData: Error = {
    //     status: response.status,
    //     message: response.data,
    //   };
    //yield put(setTokenDetails({}));
    }
  } catch (error) {
    // const errorData: Error = {
    //   status: RESPONSE_STATUS.EXCEPTION,
    //   message: "Something Went Wrong",
    // };
    // yield put(setError({ error: errorData }));
    //yield put(setTokenDetails({}));
  } finally {
   yield put(setLoader(false));
  }
}

export function* watchgetUserCountryDetails() {
  yield takeLatest("login/getUserCountryDetails", getUserCountryDetails);
}

export function* watchgetUserAccessDetails() {
  yield takeLatest("login/getUserAccessDetails", getUserAccessMenuDetails);
}

export function* watchgetLanguageDetails() {
  yield takeLatest("login/getLanguageDetails", getLanguageDetails);
}

export function* watchgetTokenDetails() {
  yield takeLatest("login/getTokenDetails", getTokenDetails);
}
